/**
 * Creates a memoized version of a function that caches results based on JSON-stringified arguments.
 *
 * @param fn - The function to memoize.
 * @returns A memoized version of the function that caches results.
 */
export const memoize = <TArgs extends any[], TReturn>(
    fn: (...args: TArgs) => TReturn,
): ((...args: TArgs) => TReturn) => {
    const cache: Record<string, TReturn> = {};
    return (...args: TArgs): TReturn => {
        const stringifiedArgs = JSON.stringify(args);
        const result = (cache[stringifiedArgs] = cache[stringifiedArgs] || fn(...args));
        return result;
    };
};
